export const COMPONENt_NAME = "verification-tabs";
